import {PropertyFilter} from './propertyFilter';

export class Query {
  filters: PropertyFilter[] = [];
}
